export default __webpack_public_path__ + "static/media/Icon-List-Delete.11bde281.svg";